import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from './header';
import styles from './Cart.module.css';
import { openWhatsAppOrder } from '../utils/whatsapp';

const Cart = ({ cartItems = 0, cartList = [], cartTotal = 0, onRemoveItem = () => {}, onQuantityChange = () => {} }) => {
  const [showCartDropdown, setShowCartDropdown] = useState(false);

  const handleCartToggle = () => {
    setShowCartDropdown(prev => !prev);
  };

  const handleDecrease = (index, quantity) => {
    console.log('handleDecrease called for index:', index, 'quantity:', quantity);
    if (quantity > 1) {
      if (onQuantityChange) {
        onQuantityChange(index, quantity - 1);
      } else {
        console.warn('onQuantityChange prop not provided');
      }
    }
  };

  const handleIncrease = (index, quantity) => {
    console.log('handleIncrease called for index:', index, 'quantity:', quantity);
    if (onQuantityChange) {
      onQuantityChange(index, quantity + 1);
    } else {
      console.warn('onQuantityChange prop not provided');
    }
  };

  const handleWhatsAppOrder = () => {
    openWhatsAppOrder(cartList);
  };

  return (
    <>
      <Header 
        cartItems={cartItems}
        cartList={cartList}
        cartTotal={cartTotal}
        showCartDropdown={showCartDropdown}
        onCartToggle={handleCartToggle}
        onRemoveItem={onRemoveItem}
      />

      <br/>      <br/>
      <br/>
      <br/>
      <br/>
      <br/>

      <div className={styles.cartContainer}>
        <h2 className={styles.title}>Your Cart</h2>
        {cartList.length === 0 ? (
          <p className={styles.emptyCart}>Your cart is empty.</p>
        ) : (
          <>
            <table className={styles.table}>
              <thead className={styles.tableHeader}>
                <tr>
                  <th>Item</th>
                  <th>Price</th>
                  <th className={styles.quantityHeader}>
                    <div className={styles.verticalCenter}>
                      Quantity
                    </div>
                  </th>
                  <th>Subtotal</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {cartList.map((item, index) => {
                  const price = parseFloat(item.item_price || item.sell_price || 0);
                  const quantity = item.quantity || 1;
                  const subtotal = price * quantity;
                  return (
                    <tr key={index} className={styles.tableRow}>
                      <td className={`${styles.tableCell} ${styles.productCell}`}>
                        <img 
                          src={item.photo_url} 
                          alt={item.item_name} 
                          className={styles.productImage}
                        />
                        <span className={styles.productName}>{item.item_name}</span>
                      </td>
                      <td className={styles.tableCell}>${price.toFixed(2)}</td>
                      <td className={`${styles.tableCell} ${styles.quantityCell}`}>
                        <button 
                          className={styles.quantityButton} 
                          onClick={() => handleDecrease(index, quantity)}
                          aria-label="Decrease quantity"
                          title="Decrease quantity"
                        >-</button>
                        <span className={styles.quantityValue}>{quantity}</span>
                        <button 
                          className={styles.quantityButton} 
                          onClick={() => handleIncrease(index, quantity)}
                          aria-label="Increase quantity"
                          title="Increase quantity"
                        >+</button>
                      </td>
                      <td className={styles.tableCell}>${subtotal.toFixed(2)}</td>
                      <td className={styles.tableCell}>
                        <button 
                          onClick={() => onRemoveItem(index)} 
                          className={styles.deleteButton}
                          aria-label="Delete item"
                          title="Delete item"
                        >
                          <i className="fa fa-trash" aria-hidden="true"></i>
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <div className={styles.totalSection}>
              Total: ${cartTotal.toFixed(2)}
            </div>
            <div className={styles.actionsRow}>
              <button
                type="button"
                onClick={handleWhatsAppOrder}
                className={styles.whatsAppButton}
              >
                <i className="fa fa-whatsapp" aria-hidden="true"></i> Order via WhatsApp
              </button>
              <Link to="/checkout" className={styles.checkoutButton}>
                Proceed to Payment
              </Link>
            </div>

             <br/>      <br/>
      <br/>
      <br/>
      <br/>
      <br/>

          </>
        )}
      </div>
    </>
  );
};

export default Cart;
